import AutoComplete from './autoComplete';
const {Option} = AutoComplete;
export {Option};
export default AutoComplete;
